import React from 'react';
import { Container, SectionHeader, Card } from '../ui';
import { TRUST } from '../../data/marketing';

// Trust & Security - honest practices for public-school buyers (no cert claims).
const TrustSecurity = () => (
  <section id="trust" className="bg-white py-16 sm:py-24 scroll-mt-16">
    <Container>
      <SectionHeader
        align="center"
        eyebrow="Trust & security"
        title="Built for school-district trust"
        subtitle="Payment and data practices designed for public schools and the families they serve."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {TRUST.map((t) => (
          <Card key={t.title} className="p-6">
            <div className="w-12 h-12 rounded-2xl bg-brand-50 flex items-center justify-center text-2xl mb-4">{t.icon}</div>
            <h3 className="text-lg font-bold font-display text-ink-900">{t.title}</h3>
            <p className="mt-2 text-ink-500 leading-relaxed">{t.desc}</p>
          </Card>
        ))}
      </div>
      <p className="text-center text-xs text-ink-400 mt-8 max-w-2xl mx-auto">
        Valley Tickets is not a certifying body. These are the practices we follow; specifics can be reviewed with your district during a demo.
      </p>
    </Container>
  </section>
);

export default TrustSecurity;
